export default __webpack_public_path__ + "static/media/PROFILE.abe846de.jpg";